(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[919],{

/***/ 75179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77360);
/* harmony import */ var _components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);



const DisplayDiscountPrice = (param)=>{
    let { discountedPrice =0 , price =0 , currencySign ="$"  } = param;
    if (discountedPrice && discountedPrice !== price) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().discountprice),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "price",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "price-discount",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                            value: discountedPrice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "discount",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                                value: price,
                                displayType: "text",
                                thousandSeparator: true,
                                prefix: currencySign,
                                decimalScale: 2,
                                fixedDecimalScale: true
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "original-price",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
            value: price,
            displayType: "text",
            thousandSeparator: true,
            prefix: currencySign,
            decimalScale: 2,
            fixedDecimalScale: true
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayDiscountPrice);


/***/ }),

/***/ 72337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55511);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57333);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36513);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39329);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);








var ref;
const ParentProductCard = (param)=>{
    let { productTitleUpSell ="" , productImageUrl =(ref = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src) !== null && ref !== void 0 ? ref : "" , customerFacingSKU ="" , name ="" , quantity =1 , unitPrice =0 , currencySign ="$" , outOfStockTitle ="" , includeTitle ="" , containerClassName ="" , includedItems ={} , availableQuantity =0 , checkChangeHandlerForParentProduct =()=>{}  } = param;
    var ref1;
    const [skuPrependName, setSkuPrependName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        checkSkuKPrepend();
    }, []);
    const checkChangeHandler = (e)=>{
        const { target: { checked =false  } = {}  } = e !== null && e !== void 0 ? e : {};
        checkChangeHandlerForParentProduct(checked, customerFacingSKU);
    };
    const isChecked = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(includedItems) ? (ref1 = includedItems[customerFacingSKU]) === null || ref1 === void 0 ? void 0 : ref1.check : false;
    const checkSkuKPrepend = async ()=>{
        var ref;
        const { apiEndPointData: { skuPrepend =""  } = {}  } = (ref = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)()) !== null && ref !== void 0 ? ref : {};
        setSkuPrependName(skuPrepend);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().leftside),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "productcard",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "left-side".concat(containerClassName),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "head",
                        children: productTitleUpSell
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "left-side--moblie",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "image",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: productImageUrl,
                                    alt: name
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "prouct-info--mobile",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-name",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-sku",
                                        children: skuPrependName.toLowerCase() === customerFacingSKU.substring(0, 2).toLowerCase() ? customerFacingSKU : "".concat(skuPrependName ? skuPrependName : "").concat(customerFacingSKU)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_7__/* .NumericFormat */ .h3, {
                                            value: unitPrice,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "product-qty",
                                        children: [
                                            "Qty: ",
                                            quantity
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pdp-upsell",
                                        children: !availableQuantity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pdp-out-of-stock",
                                            children: outOfStockTitle
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "pdp-include-div",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "pdp-checkbox",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        checked: isChecked,
                                                        onChange: checkChangeHandler
                                                    })
                                                }),
                                                includeTitle
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParentProductCard);


/***/ }),

/***/ 97217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85721);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55511);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18216);
/* harmony import */ var _components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75179);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20558);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18073);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59998);










const RequiredProductItem = (param)=>{
    let { persona ="GST" , requiredProductItem ={} , currencySign ="$" , parsedConfigs ={} , rowCols =0 , baseUrl ="" , parentSku ="" , includedItems =[] , upSellDataIndex =-1 , quantityChangeHanlder =()=>{} , updateRequiredItems =()=>{} , includeTitle ="" , recommendationTitle ="" , outOfStockTitle ="" , showQtyInput =true , dynamicClass ="" , index =1 , installServiceDataAvailable =false , cartProductData ={}  } = param;
    var ref, ref1;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        checkSkuKPrepend();
    }, []);
    const [skuPrependName, setSkuPrependName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const { sku_s: skuId = "" , ProductBrandName_s: productBrandName = "" , productName_s: productName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["productImages.labelWithUrl_ss"]: productImage = [] , availableQuantity =0  } = requiredProductItem;
    let imgId = "";
    if (productImage.length) {
        var ref2, ref3;
        const index1 = productImage.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(skuId);
        const assetId = ((ref3 = (ref2 = productImage[index1]) === null || ref2 === void 0 ? void 0 : ref2.split("|")) === null || ref3 === void 0 ? void 0 : ref3.length) ? productImage[index1].split("|")[1] : "";
        imgId = assetId;
    }
    const requiredProdImgUrl = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getPresetUrl */ .v$)(width, rowCols, baseUrl, imgId, parsedConfigs);
    var ref4;
    const isChecked = (ref4 = (ref1 = (ref = includedItems[parentSku]) === null || ref === void 0 ? void 0 : ref.includedItems[skuId]) === null || ref1 === void 0 ? void 0 : ref1.check) !== null && ref4 !== void 0 ? ref4 : false;
    const checkChangeHandler = (e, requiredProductItem)=>{
        var ref, ref1;
        const { target: { checked =false  } = {}  } = e;
        updateRequiredItems(checked, parentSku, skuId, upSellDataIndex);
        var ref2;
        const qty = (ref2 = (ref1 = (ref = includedItems[parentSku]) === null || ref === void 0 ? void 0 : ref.includedItems[skuId]) === null || ref1 === void 0 ? void 0 : ref1.quantity) !== null && ref2 !== void 0 ? ref2 : 1;
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_8__/* .addAnalyticsForIncludeforRequiredItem */ .bP)(checked, includeTitle, recommendationTitle, requiredProductItem, upSellDataIndex, installServiceDataAvailable ? index + 1 : index, persona, "", qty);
    };
    const checkSkuKPrepend = async ()=>{
        var ref;
        const { apiEndPointData: { skuPrepend =""  } = {}  } = (ref = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)()) !== null && ref !== void 0 ? ref : {};
        setSkuPrependName(skuPrepend);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().requireditem),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "required-item-for-install-service".concat(dynamicClass),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__img",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: requiredProdImgUrl,
                        alt: productBrandName
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__title",
                    children: productBrandName || productName
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__sku",
                    children: skuPrependName.toLowerCase() === skuId.substring(0, 2).toLowerCase() ? skuId : "".concat(skuPrependName ? skuPrependName : "").concat(skuId)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "required-item-for-install-service__price-quantity",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "required-item-for-install-service__price",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                discountedPrice: discountedPrice,
                                price: productPrice,
                                currencySign: currencySign
                            })
                        }),
                        showQtyInput && availableQuantity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "required-item-for-install-service__quantity",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                size: "small",
                                source: "cart-landing",
                                value: 1,
                                onChange: (qty, action)=>quantityChangeHanlder(qty, parentSku, skuId, upSellDataIndex, action, requiredProductItem, index, installServiceDataAvailable, cartProductData)
                            })
                        }) : null
                    ]
                }),
                !availableQuantity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "not-in-stock",
                    children: outOfStockTitle
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__include",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "include-div",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "checkbox",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    checked: isChecked,
                                    onChange: (e)=>checkChangeHandler(e, requiredProductItem)
                                })
                            }),
                            includeTitle
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RequiredProductItem);


/***/ }),

/***/ 59998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J_": function() { return /* binding */ addAnalyticsForADDtoCart; },
  "X1": function() { return /* binding */ addAnalyticsForArrows; },
  "Yl": function() { return /* binding */ addAnalyticsForIncludeforInstallservice; },
  "bP": function() { return /* binding */ addAnalyticsForIncludeforRequiredItem; },
  "P7": function() { return /* binding */ addAnalyticsForPdpAddToCart; },
  "uK": function() { return /* binding */ addAnalyticsForQuantitySelectorforRequiredproduct; },
  "Go": function() { return /* binding */ addAnalyticsForQuantitySelectorforinstallservice; },
  "sj": function() { return /* binding */ addAnalyticsForToolTip; },
  "GH": function() { return /* binding */ addAnalyticsForheader; },
  "AD": function() { return /* binding */ addAnalyticsPDPWhenUpSellVisible; },
  "qC": function() { return /* binding */ addAnalyticsWhenupsellvisible; }
});

// UNUSED EXPORTS: addAnalyticsForFreeServices

;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/analytics/constant.js
const BATHROOM_SERVICES = "bathroom design services";
const constant_FREE_MSG = "free kohler bathroom design plan consultation";
const NAVIGATION = "navigation";
const WAIT_TIME_FOR_LEAR_MORE = 5000;
const ADD_SERVICE = "add an install service";
const TOILET_INSTALL = "toilet install service";
const INSTALLATION_SERVICES = "installation services";
const INSTALL_SERVCIE = "install service";
const constant_COMPLIMENTARY = "complimentary plan consultation";
const ADD_TO_CART = "add to cart";

// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/analytics/index.js



const getProductInfoForAnalytics = function() {
    let cartProductData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, numberOfChilds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, isChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    if (!isEmpty_default()(cartProductData)) {
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const { site: { siteName ="n/a"  } = {}  } = page;
        const brand = siteName.toLowerCase();
        const { desc ="" , discountedPrice ="" , price ="" , globalOffer ="n/a" , globalDiscount =0 , name: productTileName = "" , category ="" , discountPriceState ="regular price " , unitPrice ="n/a" , color: productColor = "n/a" , productCoupondiscount =0 , productCouponCode ="n/a" , customerFacingSKU ="n/a" , quantity =0 , image ="n/a" , parentglobalPromotionPrice ="" , itemType ="" , productRoomType =""  } = cartProductData;
        const productId = "k" === ((ref = customerFacingSKU[0]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) ? "".concat(customerFacingSKU) : "K-".concat(customerFacingSKU);
        const productInfo = {
            description: desc.toLowerCase(),
            frequency: "n/a",
            globalPromotionPrice: parentglobalPromotionPrice ? parentglobalPromotionPrice : discountedPrice > 0 ? Number((price - 0).toFixed(2)) : 0,
            globalOffer: globalOffer,
            globalDiscount: globalDiscount.toFixed(2),
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: discountPriceState,
            productBasePrice: unitPrice,
            productCategory: category.toLowerCase(),
            productColor: productColor.toLowerCase(),
            productCoupondiscount,
            productCouponCode,
            productID: productId,
            productName: productTileName.toLowerCase() || desc.toLowerCase() || category.toLowerCase() || "n/a",
            productPartnerBuyNow: "n/a",
            productRoom: productRoomType ? productRoomType.toLowerCase() : "service",
            productSalePrice: unitPrice,
            productSaleable: true,
            productStatus: "in stock",
            productSuperSku: false,
            productTileName: productTileName.toLowerCase(),
            quantity,
            defaultImageName: image,
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: "regular finished goods & service parts",
            productFindingMethod: "n/a",
            productCollectionsName: category.toLowerCase(),
            productBrand: brand.toLowerCase(),
            itemType: itemType ? itemType.toLowerCase() : "service",
            category: category.toLowerCase()
        };
        if (index > -1) {
            productInfo.productRecommendationType = "".concat(!isChildren ? "parent" : "child", "|").concat(index + 1, "(").concat(numberOfChilds, ")");
        }
        return productInfo;
    }
    return false;
};
const getrequiredProductInfo = function() {
    let productinfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, childindex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, persona = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", qty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, isParent = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var ref, ref1, ref2, ref3, ref4;
    const { ProductDescriptionProductShort_s: decs = "" , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = "0" , CustomerFacingBrand_s: brandName = "" , Product_Category: productCategory = "" , RegionBrandName_s: Name = "" , availableQuantity =0 , sku_s: skuid = "" , discountPriceState ="regular price " , productCoupondiscount =0 , productCouponCode ="n/a" , ["productImages.url_ss"]: productImage = [] , ["priceList.".concat(persona, ".finalPrice_d")]: baseprice = 0 , masterSKU_s: mastersku = "" , unitPrice: unitPrice = "" , productParentImage: productParentImage = "" , productColor: productColor = "default" , parentglobalPromotionPrice ="" , itemType ="" , productRoomType ="" , productPrice =""  } = productinfo;
    const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
    const isPdp = (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp";
    var ref5;
    const skuProductId = (ref5 = skuid !== null && skuid !== void 0 ? skuid : mastersku) !== null && ref5 !== void 0 ? ref5 : "";
    const productId = "k" === ((ref3 = skuProductId[0]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) ? "".concat(skuProductId) : "K-".concat(skuProductId);
    const productInfo = {
        description: decs.toLowerCase(),
        frequency: "n/a",
        globalPromotionPrice: parentglobalPromotionPrice ? parentglobalPromotionPrice : discountedPrice > 0 ? Number((ref4 = baseprice - 0) === null || ref4 === void 0 ? void 0 : ref4.toFixed(2)) : 0,
        globalOffer: "n/a",
        globalDiscount: discountedPrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: unitPrice || baseprice,
        productCategory: productCategory.toLowerCase(),
        productColor: productColor.toLowerCase(),
        productCoupondiscount,
        productCouponCode,
        productID: productId,
        productName: Name.toLowerCase() || decs.toLowerCase() || productCategory.toLowerCase() || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: productRoomType ? productRoomType.toLowerCase() : "service",
        productSalePrice: productPrice || unitPrice || baseprice,
        productSaleable: true,
        productStatus: availableQuantity ? "in stock" : "out of stock",
        productSuperSku: false,
        productTileName: Name.toLowerCase() || "n/a",
        quantity: isPdp ? 1 : qty,
        defaultImageName: productParentImage || productImage[0],
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: productCategory.toLowerCase(),
        productBrand: brandName.toLowerCase(),
        itemType: itemType ? itemType.toLowerCase() : "service",
        category: productCategory.toLowerCase()
    };
    if (index > -1 && childindex > -1) {
        productInfo.productRecommendationType = "".concat(isParent ? "parent" : "child", "|").concat(index + 1, "(").concat(productinfo.foundIndex ? productinfo.foundIndex + 1 : childindex + 1, ")");
    }
    return productInfo;
};
const getserviceproductData = function() {
    let servicedata = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceQTY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", isInstallService = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", qty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    var ref;
    const { description ="" , discountedPrice =0 , price =0 , name ="" , customerBrand ="" , productCategory ="" , skuId ="" , swatchUrl ="" , images ="" , quantity =1  } = servicedata;
    const productId = "k" === ((ref = skuId[0]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) ? "".concat(skuId) : "K-".concat(skuId);
    const isInstallServiceImage = isInstallService ? "".concat(swatchUrl).concat(images, "?$SellModalDesktop$") : "";
    const serviceData = {
        defaultImageName: isInstallService ? isInstallServiceImage : "n/a",
        description: description.toLowerCase(),
        frequency: "n/a",
        globalPromotionPrice: discountedPrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        numberOfReviews: "n/a",
        pdpType: productCategory.toLowerCase(),
        priceState: "regular price",
        productBasePrice: price,
        productBrand: customerBrand.toLowerCase(),
        productCategory: productCategory.toLowerCase(),
        productCollectionsName: name.toLowerCase(),
        productColor: "n/a",
        productCouponCode: "n/a",
        productCoupondiscount: "n/a",
        productFindingMethod: "n/a",
        productID: productId ? productId : productCategory,
        productName: name.toLowerCase(),
        productPartnerBuyNow: "n/a",
        productRoom: productCategory.toLowerCase(),
        productSalePrice: discountedPrice,
        productSaleable: "true",
        productStatus: "in stock",
        productSuperSku: "false",
        productTileName: "installation services",
        quantity: qty ? qty : isInstallService ? quantity : serviceQTY,
        ratings: "n/a",
        productRecommendationType: "child|".concat(index + 1, "(1)")
    };
    return serviceData;
};
const addAnalyticsForToolTip = function(servicename, title, url, cartProductData, recommendationTitle) {
    let upSellDataIndex = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", childProductIndex = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", isChildren = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", item = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {}, qty = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : 1, isCartAction = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : "";
    var ref;
    const services = servicename.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const recommended = recommendationTitle === null || recommendationTitle === void 0 ? void 0 : recommendationTitle.toLowerCase();
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const statusEvent = title == "add to cart" ? constants.SUCCESS : "n/a";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell products:".concat(recommended, ":").concat(title),
        eventMsg: "n/a",
        eventName: "".concat(pageload, ":").concat(recommended, ":").concat(title),
        eventStatus: statusEvent,
        eventType: title == "add to cart" ? "navigation" : "teaser",
        internalLinkName: title.toLowerCase(),
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(services),
        internalLinkURL: url ? url : "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(recommended)
    };
    if ((item === null || item === void 0 ? void 0 : (ref = item.installServiceData) === null || ref === void 0 ? void 0 : ref.discountedPrice) && isCartAction) {
        var ref1;
        eventInfo.upsellCartValueData = (item === null || item === void 0 ? void 0 : (ref1 = item.installServiceData) === null || ref1 === void 0 ? void 0 : ref1.discountedPrice) * qty;
    }
    const serviceinfoDetails = getserviceproductData(item === null || item === void 0 ? void 0 : item.installServiceData, 1, upSellDataIndex, 1);
    const productInfoItems = [
        serviceinfoDetails
    ];
    pushAnalyticsObjToDataLayer(eventInfo, productInfoItems);
};
const addAnalyticsForheader = (zipcode, title, recommendationTitle, serviceAvailableTitleUpSell)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const titleName = title.toLowerCase();
    const recommendation = recommendationTitle === null || recommendationTitle === void 0 ? void 0 : recommendationTitle.toLowerCase();
    if (titleName === "change zip code") {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "upsell products:".concat(recommendation, ":").concat(titleName),
            eventMsg: "n/a",
            eventName: "".concat(pageload, ":").concat(recommendation, ":").concat(titleName),
            eventStatus: "n/a",
            eventType: NAVIGATION,
            internalLinkName: titleName,
            internalLinkPosition: "".concat(pageload, ":upsell"),
            internalLinkType: "".concat(pageload, ":").concat(zipcode),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(pageload, ":").concat(recommendation)
        };
        pushAnalyticsObjToDataLayer(eventInfo);
    } else {
        const eventInfo1 = {
            clickInternalLinks: "true",
            eventAction: "upsell products :".concat(INSTALLATION_SERVICES.toLowerCase(), ":").concat(INSTALL_SERVCIE.toLowerCase(), ":check availability"),
            eventMsg: "n/a",
            eventName: "".concat(pageload, ":").concat(recommendation, ":check availability"),
            eventStatus: constants.SUCCESS,
            eventType: NAVIGATION,
            internalLinkName: "search",
            internalLinkPosition: "".concat(pageload, ":").concat(recommendation, ":upsell"),
            internalLinkType: "".concat(pageload, ":").concat(zipcode),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(pageload, ":").concat(recommendation)
        };
        pushAnalyticsObjToDataLayer(eventInfo1);
    }
};
const addAnalyticsForFreeServices = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const titleInfo = title.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell products:".concat(FREE_MSG, ": ").concat(titleInfo),
        eventMsg: "n/a",
        eventName: "".concat(pageload, ":").concat(FREE_MSG, ":").concat(titleInfo, " "),
        eventStatus: "n/a",
        eventType: "teaser",
        internalLinkName: titleInfo,
        internalLinkPosition: "".concat(pageload, ":teaser"),
        internalLinkType: "".concat(pageload, ":").concat(COMPLIMENTARY),
        internalLinkURL: url ? url : "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(COMPLIMENTARY)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsForArrows = function() {
    let label = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", upsellData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], index = arguments.length > 2 ? arguments[2] : void 0, persona = arguments.length > 3 ? arguments[3] : void 0, serviceAvailableTitleUpSell = arguments.length > 4 ? arguments[4] : void 0, recommendationTitle = arguments.length > 5 ? arguments[5] : void 0;
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const type = label == "Next" ? "right" : "left";
    const title = (upsellData === null || upsellData === void 0 ? void 0 : (ref = upsellData.requiredItems) === null || ref === void 0 ? void 0 : ref.length) ? recommendationTitle.toLowerCase() : serviceAvailableTitleUpSell.toLowerCase();
    const productInfoforCart = [];
    const productInfoforRequiredItems = [];
    const firstVisibleItem = upsellData ? upsellData : {};
    const { cartProductData ={} , requiredItems =[] , installServiceData ={}  } = firstVisibleItem;
    let installServiceInfo = "";
    if (!isEmpty_default()(installServiceData)) {
        installServiceInfo = {
            ["ProductDescriptionProductShort_s"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.narrativeDescription,
            ["Product_Category"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.productCategory,
            image: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.productImageUrl,
            unitPrice: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.price,
            customerFacingSKU: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerFacingSKU,
            productTileName: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.name,
            ["CustomerFacingBrand_s"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerBrand,
            availableQuantity: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.quantity,
            sku_s: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerFacingSKU,
            productParentImage: "".concat(installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.swatchUrl).concat(installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.images, "?$SellModalDesktop$"),
            parentglobalPromotionPrice: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.discountedPrice,
            productPrice: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.discountedPrice
        };
    }
    const requiredDataWithInstallServiceInfo = [
        installServiceInfo,
        ...requiredItems
    ];
    var ref1;
    const cartProductInfo = (ref1 = getProductInfoForAnalytics(cartProductData, index, requiredDataWithInstallServiceInfo.length)) !== null && ref1 !== void 0 ? ref1 : {};
    productInfoforCart.push(cartProductInfo);
    var ref2;
    const requiredProductInfo = requiredDataWithInstallServiceInfo.map((item, childindex)=>(ref2 = getrequiredProductInfo(item, childindex, index, persona)) !== null && ref2 !== void 0 ? ref2 : []);
    productInfoforRequiredItems.push(requiredProductInfo);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell products: ".concat(title, ": ").concat(type, " arrow"),
        eventMsg: "n/a",
        eventName: "".concat(pageload, ":").concat(title, ": ").concat(type, " arrow"),
        eventStatus: "n/a",
        eventType: "carousel",
        internalLinkName: "".concat(type, " arrow"),
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(title),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(title)
    };
    const productInfoItems = productInfoforCart.concat(productInfoforRequiredItems.flat(2));
    pushAnalyticsObjToDataLayer(eventInfo, productInfoItems);
};
const addAnalyticsForADDtoCart = function() {
    let productinfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, servicechecked = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", servicedata = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, persona = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "GST", serviceQTY = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, subTotal = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "cart preview: cart update: ".concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventName: "cart preview: cart update: ".concat(ADD_TO_CART),
        eventStatus: "n/a",
        eventType: "naviagtion",
        internalLinkName: "add to cart",
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(ADD_TO_CART),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":preview"),
        upsellCartValue: subTotal
    };
    const arr = productinfo.map((item)=>{
        const { childindex =-1 , index =-1 , totalQTY =1  } = item;
        return getrequiredProductInfo(item, childindex, index, persona, totalQTY);
    });
    pushAnalyticsObjToDataLayer(eventInfo, arr);
};
const addAnalyticsWhenupsellvisible = function() {
    let recommendation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productDataForAnlytics = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, persona = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const recommendationtitle = recommendation.toLowerCase();
    const productInfoforCart = [];
    const productInfoforRequiredItems = [];
    const { parentProductData ={} , requiredItems =[]  } = productDataForAnlytics;
    var ref;
    const cartProductInfo = (ref = getProductInfoForAnalytics(parentProductData, 0, requiredItems.length)) !== null && ref !== void 0 ? ref : {};
    productInfoforCart.push(cartProductInfo);
    var ref1;
    const requiredProductInfo = requiredItems.map((item, childindex)=>(ref1 = getrequiredProductInfo(item, childindex, 0, persona)) !== null && ref1 !== void 0 ? ref1 : []);
    productInfoforRequiredItems.push(requiredProductInfo);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell products:".concat(recommendationtitle, ":product recommendation displayed "),
        eventMsg: "n/a",
        eventName: "upsell products:".concat(recommendationtitle, ":product recommendation displayed "),
        eventStatus: "n/a",
        eventType: "teaser",
        internalLinkName: "product recommendation displayed",
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":product recommendation displayed"),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(recommendationtitle)
    };
    const productInfoItems = productInfoforCart.concat(productInfoforRequiredItems.flat(2));
    pushAnalyticsObjToDataLayer(eventInfo, productInfoItems);
};
const addAnalyticsForIncludeforInstallservice = function() {
    let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, included = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", recommendationTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", installServiceData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, index = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const includetitle = included.toLowerCase();
    const recommendation = recommendationTitle.toLowerCase();
    const check = checked ? "select" : "remove";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell product:".concat(recommendation, ": ").concat(includetitle, " ").concat(check),
        eventMsg: "n/a",
        eventName: "upsell product:".concat(recommendation, ": ").concat(includetitle, " ").concat(check),
        eventStatus: "n/a",
        eventType: "teaser",
        internalLinkName: "".concat(includetitle, ":").concat(check),
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(includetitle),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(recommendation)
    };
    const serviceinfo = getserviceproductData(installServiceData, 1, index);
    pushAnalyticsObjToDataLayer(eventInfo, serviceinfo);
};
const addAnalyticsForIncludeforRequiredItem = function() {
    let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, included = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", recommendationTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", installServiceData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, index = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, childindex = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : -1, persona = arguments.length > 6 ? arguments[6] : void 0, isParent = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false, qty = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 1;
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const isPdp = (page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType) === "pdp" ? "pdp:" : "";
    const parentIndex = isPdp ? 0 : index;
    const includetitle = included.toLowerCase();
    const recommendation = recommendationTitle.toLowerCase();
    const check = checked ? "select" : "remove";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(isPdp, "upsell product:").concat(recommendation, ": ").concat(includetitle, " ").concat(check),
        eventMsg: "n/a",
        eventName: "".concat(isPdp, "upsell product:").concat(recommendation, ": ").concat(includetitle, " ").concat(check),
        eventStatus: "n/a",
        eventType: "teaser",
        internalLinkName: "".concat(includetitle, ": ").concat(check),
        internalLinkPosition: "".concat(isPdp ? isPdp : "".concat(pageload, ":"), "upsell"),
        internalLinkType: "".concat(isPdp ? isPdp : "".concat(pageload, ":")).concat(includetitle),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(isPdp ? isPdp : "".concat(pageload, ":")).concat(recommendation)
    };
    const serviceinfo = getrequiredProductInfo(installServiceData, childindex, parentIndex, persona, qty, isParent);
    pushAnalyticsObjToDataLayer(eventInfo, serviceinfo);
};
const addAnalyticsForQuantitySelectorforinstallservice = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", installServiceData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, item = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, qty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const indextitle = action === "add" ? "addition" : "removal";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "cart preview: cart update: ".concat(action),
        eventMsg: "n/a",
        eventName: "cart preview: cart update: ".concat(action),
        eventStatus: "n/a",
        eventType: "naviagtion",
        internalLinkName: "cart update",
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(indextitle),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":preview")
    };
    const serviceinfoData = installServiceData ? getserviceproductData(installServiceData, 1, index, 1, qty) : null;
    const productInfoItems = [
        serviceinfoData
    ];
    pushAnalyticsObjToDataLayer(eventInfo, productInfoItems);
};
const addAnalyticsForQuantitySelectorforRequiredproduct = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", requiredproductData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, parentIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, childindex = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, persona = arguments.length > 4 ? arguments[4] : void 0, qty = arguments.length > 5 ? arguments[5] : void 0, cartProductData = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, installServiceDataAvailable = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const indextitle = index === "add" ? "addition" : "removal";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "cart preview: cart update: ".concat(index),
        eventMsg: "n/a",
        eventName: "cart preview: cart update: ".concat(index),
        eventStatus: "n/a",
        eventType: "naviagtion",
        internalLinkName: "cart update",
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(indextitle),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":preview")
    };
    const serviceinfoData = requiredproductData ? getrequiredProductInfo(requiredproductData, childindex, parentIndex, persona, qty) : null;
    const productInfoItems = [
        serviceinfoData
    ];
    pushAnalyticsObjToDataLayer(eventInfo, productInfoItems);
};
const addAnalyticsForPdpAddToCart = function() {
    let subTotal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productDataForAnlytics = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, persona = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "GST";
    var ref;
    const productInfoforCart = [];
    const productInfoforRequiredItems = [];
    const { parentProductDataAll ={} , selectedIncludePdpData =[]  } = productDataForAnlytics;
    var ref1;
    const cartProductInfo = (ref1 = getProductInfoForAnalytics(parentProductDataAll ? parentProductDataAll : "", 0, selectedIncludePdpData.length)) !== null && ref1 !== void 0 ? ref1 : {};
    if (cartProductInfo) {
        productInfoforCart.push(cartProductInfo);
    }
    const totalQTY = 1;
    var ref2;
    const requiredProductInfo = selectedIncludePdpData.map((item)=>(ref2 = getrequiredProductInfo(item, "", 0, persona, totalQTY)) !== null && ref2 !== void 0 ? ref2 : []);
    productInfoforRequiredItems.push(requiredProductInfo);
    const price = Number(subTotal).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const isPdp = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(isPdp, ":product details:upsell products:").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventName: "".concat(isPdp, ":product details:upsell products:").concat(ADD_TO_CART),
        eventStatus: "n/a",
        eventType: "naviagtion",
        internalLinkName: ADD_TO_CART,
        internalLinkPosition: "".concat(isPdp, ":upsell"),
        internalLinkType: "".concat(isPdp, ": ").concat(ADD_TO_CART),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(isPdp, ":product details"),
        upsellCartValue: price
    };
    const productInfoItems = productInfoforCart.concat(productInfoforRequiredItems.flat(2));
    pushAnalyticsObjToDataLayer(eventInfo, productInfoItems);
};
const addAnalyticsPDPWhenUpSellVisible = function() {
    let recommendation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productDataForAnlytics = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, persona = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    const recommendationtitle = recommendation.toLowerCase();
    const productInfoforCart = [];
    const productInfoforRequiredItems = [];
    const { parentProductDataAll ={} , requiredItemsProductData =[]  } = productDataForAnlytics;
    var ref;
    const cartProductInfo = (ref = getProductInfoForAnalytics(parentProductDataAll, 0, requiredItemsProductData.length)) !== null && ref !== void 0 ? ref : {};
    productInfoforCart.push(cartProductInfo);
    var ref1;
    const requiredProductInfo = requiredItemsProductData.map((item, childindex)=>(ref1 = getrequiredProductInfo(item, childindex, 0, persona)) !== null && ref1 !== void 0 ? ref1 : []);
    productInfoforRequiredItems.push(requiredProductInfo);
    const eventInfo = {
        clickInternalLinks: "false",
        eventAction: "pdp:upsell products:".concat(recommendationtitle, ":product recommendation displayed"),
        eventMsg: "n/a",
        eventName: "pdp:upsell products:".concat(recommendationtitle, ":product recommendation displayed"),
        eventStatus: "n/a",
        eventType: "teaser",
        internalLinkName: "product recommendation displayed",
        internalLinkPosition: "pdp:upsell",
        internalLinkType: "pdp:product recommendation displayed",
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:".concat(recommendationtitle)
    };
    const productInfoItems = productInfoforCart.concat(productInfoforRequiredItems.flat(2));
    pushAnalyticsObjToDataLayer(eventInfo, productInfoItems);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cartProductData = arguments.length > 1 ? arguments[1] : void 0;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const productInfo = cartProductData || "null";
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};



/***/ }),

/***/ 77360:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"original-price":"DisplayDiscountPrice_original-price__NHYKU","discountprice":"DisplayDiscountPrice_discountprice__mIQmW"};

/***/ }),

/***/ 39329:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leftside":"ParentProductCard_leftside__kH9XN"};

/***/ }),

/***/ 18073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"requireditem":"RequiredProductItem_requireditem__38ZzY"};

/***/ })

}]);